/* fw-sticky-atc-script-20260715 */
(function(){
  if (window.__fwStickyAtcInit) return;
  window.__fwStickyAtcInit = true;

  // NOTE: PageFly client-side re-renders the product form after initial paint,
  // which can swap/replace DOM nodes. We deliberately avoid caching element
  // references (IntersectionObserver/MutationObserver targets) and instead
  // re-query the live DOM on every tick, so the bar keeps working after re-render.

  function getRealBtn(){
    return document.querySelector('[data-pf-type="ProductATC2"][data-checkout="cart"]')
        || document.querySelector('.fwv2__add')
        || document.querySelector('.fwv3__add');
  }

  function init(){
    var bar = document.getElementById('fw-sticky-atc');
    var titleEl = document.getElementById('fw-sticky-atc-title');
    var priceEl = document.getElementById('fw-sticky-atc-price');
    var variantEl = document.getElementById('fw-sticky-atc-variant');
    var btn = document.getElementById('fw-sticky-atc-btn');
    if (!bar || !btn) return;

    var adding = false;
    var variantById = null;
    (function loadVariants(){
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(p){
          var map = {}, multi = p.variants && p.variants.length > 1;
          (p.variants || []).forEach(function(v){ map[String(v.id)] = v.title; });
          variantById = multi ? map : {};
        }).catch(function(){});
    })();

    /* Aria 2026-08-15 perf: these setters previously wrote textContent/style on
       every 500 ms tick whether or not the value had changed. Each write dirtied
       layout and tick() then read getBoundingClientRect() immediately after, which
       forced a synchronous layout twice a second for the life of the page (244 ms
       of CPU in a 10 s profile = the single biggest theme-owned cost on the PDP).
       Guarding every write makes the steady state read-only, so the rect read is
       free. Node lookups stay UNCACHED on purpose - PageFly swaps these nodes. */
    function setText(el, v){ if (el && el.textContent !== v) el.textContent = v; }

    function syncInfo(){
      var h1 = document.querySelector('h1[data-pf-type="ProductTitle"]') || document.querySelector('h1');
      var priceNode = document.querySelector('[data-product-price="true"]') || document.querySelector('[data-product-price]');
      if (h1) {
        var t = h1.textContent.replace(/\s+/g, ' ').trim();
        setText(titleEl, t.length > 34 ? t.slice(0, 33) + '…' : t);
      }
      if (priceNode) {
        setText(priceEl, priceNode.textContent.trim());
      }
      if (variantEl) {
        var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('input[name="id"]');
        var vt = (idInput && variantById) ? variantById[idInput.value] : '';
        if (vt && vt !== 'Default Title') {
          vt = vt.replace(/\s*\/\s*/g, ' / ');
          setText(variantEl, vt.length > 40 ? vt.slice(0, 39) + '\u2026' : vt);
          if (variantEl.style.display !== '') variantEl.style.display = '';
        } else {
          setText(variantEl, '');
          if (variantEl.style.display !== 'none') variantEl.style.display = 'none';
        }
      }
    }

    function syncBtnState(realBtn){
      if (!realBtn) { if (!btn.disabled) btn.disabled = true; return; }
      if (adding) return; // don't fight the "Adding…"/"Added ✓" transient state
      if (btn.disabled !== !!realBtn.disabled) btn.disabled = !!realBtn.disabled;
      var label = (realBtn.textContent || '').trim();
      setText(btn, label === 'Sold out' ? 'Sold out' : 'Add to Cart');
    }

    var chatEl = document.querySelector('.fcw-chat-container');
    var repairEl = document.querySelector('.fcw-container');
    function setBarVisible(visible){
      var isMobile = window.innerWidth < 768;
      var show = visible && isMobile;
      var wasShown = bar.classList.contains('fw-sticky-atc-visible');
      if (show !== wasShown) {
        bar.classList.remove('fw-sticky-atc-interactive');
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) {
          // Reserve page space first, then start the slide. The bar remains untappable
          // until its transform transition has actually settled.
          document.body.classList.add('fw-sticky-atc-active');
          void bar.offsetHeight;
          bar.classList.add('fw-sticky-atc-visible');
          var enable = function(){
            if (bar.classList.contains('fw-sticky-atc-visible')) bar.classList.add('fw-sticky-atc-interactive');
          };
          bar.addEventListener('transitionend', enable, { once: true });
          setTimeout(enable, 300);
          var h = bar.offsetHeight || 62;
          if (chatEl) chatEl.style.setProperty('bottom', (h + 12) + 'px', 'important');
          if (repairEl) repairEl.style.setProperty('bottom', (h + 12) + 'px', 'important');
        } else {
          bar.classList.remove('fw-sticky-atc-visible');
          document.body.classList.remove('fw-sticky-atc-active');
          if (chatEl) chatEl.style.removeProperty('bottom');
          if (repairEl) repairEl.style.removeProperty('bottom');
        }
      }
    }

    function tick(){
      if (document.hidden) return;
      var realBtn = getRealBtn();
      syncInfo();
      syncBtnState(realBtn);
      if (!realBtn || window.innerWidth >= 768) {
        setBarVisible(false);
        return;
      }
      var rect = realBtn.getBoundingClientRect();
      setBarVisible(rect.bottom < 0);
    }

    // rAF-throttled scroll handling
    var ticking = false;
    function onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        tick();
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Poll on an interval too — catches variant/price swaps and PageFly
    // re-renders that don't happen to coincide with a scroll event.
    setInterval(tick, 500);
    tick();

    // AddToCart pixel: this bar just proxies a click on the real PageFly
    // button below, so the real /cart/add AJAX call happens exactly as if
    // the shopper had clicked it directly — Shopify's native Meta channel
    // tracking (Web Pixels sandbox) already fires AddToCart on that call,
    // so this button intentionally does NOT fire its own pixel event
    // (verified 2026-07-15: firing one here double-counted with Shopify's
    // native tracking, which was already correctly reporting AddToCart for
    // every successful /cart/add — see memory/FW-Native-ATC-Pixel-Patch-2026-07-15.md).

    btn.addEventListener('click', function(){
      var realBtn = getRealBtn();
      if (adding || !realBtn || realBtn.disabled) return;
      adding = true;
      // Same animation as the main v2/v3 add button (fw-atc-busy / fw-atc-done in
      // fw-inline-10.css): spinner while adding, green gradient + tick when confirmed.
      btn.classList.remove('fw-atc-done');
      btn.classList.add('fw-atc-busy');
      btn.textContent = 'Adding…';
      realBtn.click();
      setTimeout(function(){
        btn.classList.remove('fw-atc-busy');
        btn.classList.add('fw-atc-done');
        btn.textContent = 'Added';
        setTimeout(function(){
          btn.classList.remove('fw-atc-busy', 'fw-atc-done');
          adding = false;
          tick();
        }, 1400);
      }, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* fw-review-badge-to-tab-20260718 */
(function(){
  if (window.__fwReviewBadgeToTab) return;
  window.__fwReviewBadgeToTab = true;
  function vis(el){ return !!(el && (el.offsetWidth>0 || el.offsetHeight>0 || el.getClientRects().length>0)); }
  function reviewsTab(){
    var hs = document.querySelectorAll('button[data-pf-type="TabHeader"]');
    var fb = null;
    for (var i=0;i<hs.length;i++){
      if(/review/i.test(hs[i].textContent||'')){ if(vis(hs[i])) return hs[i]; fb = fb||hs[i]; }
    }
    return fb;
  }
  function openReviews(){
    var tab = reviewsTab();
    if(!tab) return false;
    tab.click();
    setTimeout(function(){
      var widgets = document.querySelectorAll('.jdgm-rev-widg');
      var target = null;
      for (var i=0;i<widgets.length;i++){ if(vis(widgets[i])){ target = widgets[i]; break; } }
      if(!target){
        var tabsWrap = tab.closest('[data-pf-type="Tabs"]');
        target = (tabsWrap && vis(tabsWrap)) ? tabsWrap : tab;
      }
      if(target && target.scrollIntoView) target.scrollIntoView({behavior:'smooth', block:'start'});
    }, 220);
    return true;
  }
  document.addEventListener('click', function(e){
    var t = e.target;
    var badge = t.closest && t.closest('.jdgm-prev-badge, .jdgm-prev-badge__text, .jdgm-prev-badge__stars, .jdgm-star, [class*="jdgm-prev-badge"]');
    if(!badge) return;
    if(openReviews()){ e.preventDefault(); e.stopPropagation(); }
  }, true);
})();


/* fw-atc-sticky-allsizes-20260815 : mirror the main add-to-cart button's animation onto
   the tablet/desktop section sticky bar button. That button only proxies a click on the
   main button, so instead of duplicating any timing we observe the main button's class
   and copy it - the two can never drift out of sync. */
(function(){
  if (window.__fwSectionStickyAtc) return;
  window.__fwSectionStickyAtc = true;
  var SEL = '[data-fwv2-sticky-add],[data-fwv3-sticky-add]';
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!b || b.disabled) return;
    var main = document.querySelector('.fwv2__add,.fwv3__add');
    if (!main || !window.MutationObserver) return;
    var orig = (b.textContent || '').trim();
    function apply(){
      var busy = main.classList.contains('fw-atc-busy');
      var done = main.classList.contains('fw-atc-done');
      b.classList.toggle('fw-atc-busy', busy);
      b.classList.toggle('fw-atc-done', done);
      var t = busy ? 'Adding\u2026' : (done ? 'Added' : orig);
      if (b.textContent !== t) b.textContent = t;
      // Keep the sticky control enabled; the main form button alone owns fetch state.
    }
    var mo = new MutationObserver(apply);
    mo.observe(main, { attributes: true, attributeFilter: ['class'] });
    apply();
    setTimeout(function(){
      mo.disconnect();
      b.classList.remove('fw-atc-busy', 'fw-atc-done');
      if ((b.textContent || '').trim() !== orig) b.textContent = orig;
    }, 6000);
  }, true);
})();
